"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _lodash = _interopRequireDefault(require("lodash.get"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = isAssetMissing;

function isAssetMissing(a) {
  var b = (a || {}).assetFiles;
  return b && "MISSING" === (0, _lodash["default"])(b, "ORIGINAL.status");
}